import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import Home from "./rotas/rotasPrincipais/Home/home";
import ResumoGeral from './rotas/rotasPrincipais/ResumoGeral/ResumoGeral';
import Entradas from './rotas/rotasPrincipais/Entradas/Entradas';
import Saidas from './rotas/rotasPrincipais/Saidas/Saidas';
import RotaProtegida from './rotas/rotasPrincipais/RotaProtegida';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';


import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { AdicionandoDados } from './context/AdicionandoDados';
import Funcionarios from './rotas/rotasPrincipais/Funcionarios/Funcionarios';
import Projetos from './rotas/rotasPrincipais/Projetos/Funcionarios';

const App = () => {
  const [estaAdicionandoDados, setEstaAdicionandoDados] = useState(false);

  return (
    <AdicionandoDados.Provider value={{ estaAdicionandoDados, setEstaAdicionandoDados }}>
      
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/resumogeral" element={<RotaProtegida element={<ResumoGeral />} />}
          />
            <Route path="/entradas" element={<RotaProtegida element={<Entradas />} />} />
            <Route path="/saidas" element={<RotaProtegida element={<Saidas />} />} />
            <Route path="/funcionarios" element={<RotaProtegida element={<Funcionarios />} />} />
            <Route path="/configuracoes" element={<RotaProtegida element={<Projetos />} />} />
          </Routes>
        </Router>
      
    </AdicionandoDados.Provider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);
